import { useSyncGrowthbookUserAttributes } from 'growthbook/client'
import { HelpBots } from 'help-bots'
import Head from 'next/head'
import React from 'react'
import { Banner } from 'shared/components/banner'
import { Navbar } from 'shared/components/navbar'
import { useGuard } from 'shared/hooks/use-guard'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { useRedirectDisabledUser } from 'shared/hooks/use-redirect-disabled-user'
import { CONTENT_CLASSNAME } from 'shared/layout/constants/layout-class-names'
import { useEmailStatusNotification } from 'shared/notifications/hooks/use-email-status-notification'
import { usePaymentNotification } from 'shared/notifications/hooks/use-payment-notification'
import { twMerge } from 'tailwind-merge'
import { Snow } from './snow'
import { useChristmas } from './snow/use-christmas'

interface DashboardLayoutProps extends React.PropsWithChildren {
  browserTabTitle: string
}

function DashboardLayout({ children, browserTabTitle }: DashboardLayoutProps) {
  useGuard()
  usePaymentNotification()
  useEmailStatusNotification()
  useRedirectDisabledUser()
  useSyncGrowthbookUserAttributes()

  const christmasFeatureIsOn = useChristmas()

  const { t } = useLocoTranslation()

  return (
    <>
      <HelpBots />
      <Head>
        <title>{t(browserTabTitle)}</title>
      </Head>
      <div>
        <Navbar />
        <Banner />
        <main className={twMerge(CONTENT_CLASSNAME, 'py-5')}>{children}</main>
      </div>
      {christmasFeatureIsOn && <Snow />}
    </>
  )
}

export default DashboardLayout
